import { BeatLoader } from "react-spinners";
import { Constants } from "../../../../../common/constants";

export function SubpageLoader() {
	const vertical_spacers: JSX.Element[] = [];
	for (let i = 0; i < 7; i++) {
		vertical_spacers.push(<div key={i} className="py-4" />);
	}

	return (
		<div>
			{vertical_spacers}
			<div className="is-centered sweet-loading throbber">
				<div>
					<BeatLoader
						size={"1.5rem"}
						loading={true}
						color={Constants.EMBED_COLOR}
					/>
				</div>
			</div>
			{vertical_spacers}
		</div>
	);
}
